import React, { useMemo } from "react";

const Tooltip = ({ text, className, children, position }) => {
  
  const memoizedChildren = useMemo(() => children, [children]);

  return (
    <div className={`tooltip ${className}`}>
      {memoizedChildren}
      <div className={`container ${position || "top"}`}>
        <div className="inner">
          {text}
        </div>
      </div>
    </div>
  );
};

export default Tooltip;
